// Search Trigger Group Form and Search Table(2700423152)
/*
Sohel 09/27/2022 2700489754  Trigger group Client and Agency Type Changes
Sohel 09/29/2022 2700489754 Added Toast, validation and Event Trigger Changes
Sohel 10/10/2022 2699758070 Removed unused Code
Sohel 10/12/2022 2700430604 Added breadcrumbs,label changes,pagination changes
Sohel 10/14/2022 2700489754 Added Comments
Raghu 27/10/2022 2700489754 Input Field Enhancements and Font size fixes
Raghu 28/10/2022 2700489754 Input Field Alignments
Suresh Peddavoora 11/03/2022 2700489754 Button Alignments in Tab Resolution
Sohel 11/04/2022 2700489754 Access method label Changes
Sohel 11/04/2022 2699818958 Implement Run Batch Trigger Group Functionality
Rajesh 11/18/2022 2699818958 added batch tirgger for night jobs.
Sohel 11/18/2022 2700489754 run Batch trigger Group changes
akhila 11/19/2022 2700489754 passing trigger data to night jobs
Sohel 11/22/2022 2700271704 fixed search Table reset Issue
Ashraf 11/23/2022 2701012930 fixed fetching filter method dropdown options
Suresh Peddavoora 11/24/2022 2700430604 Added class name conditionally to Render in DialogBox
Akhila 11/25/2022 2700489754 textField label name, placeholder change
akhila 11/26/2022 2700430604 changed labels for code and description
Rajesh 11/28/2022 2700430604 fixed  filter dropdown values display in night jobs .
Suresh Peddavoora 11/30/2022 2700430604 Changed class name for Spacing Alignments
Suresh Peddavoora 12/01/2022 2700430604 Fixed TextField Alignments Conditionally in DialogBox
akhila 12/08/2022 2700430604 added session storage for search items
lalitha 12/09/2022 2700430604 Added Created Date Field
Raghu 12/09/2022  2700430604 Field alignment Fixes
Raghu 12/12/2022 2700430604 Button alignment fixes
Akhila 12/13/2022 2700430604 bugFix session stoarge
Prakash Gummala 12/20/2022 2700430604 inputfield Alignments for tab resolution.
Prakash 12/22/2022 2700430604 input field Alignments Responsiveness.
Raghu 12/28/2022 2700430604 Responsive Alignment Fixes
Dilip 12/30/2022 2700430604 renamed labels for code and description
Dilip 02/09/2023 2700430604 added  created by dropdown
Sohel 02/15/2023 2700430604  night Job Status Changes
Ravi 02/20/2023 2700430604  fixed disable issue
Raghu 02/23/2023 2700430604 fixed new Ui changes
Raghu 02/27/2023 2700430604 fixed input alignments
Raghu 02/27/2023 2700430604 fixed alignments
Raghu 02/28/2023 2700271704 fixed new ui alignments
Raghu 03/06/2023 2700271704 added new classname for date picker
Sohel 04/04/2023 2700271704 Fixed Batch Trigger Status Issue
Akhila 06/08/2023 2699234404 created date change to date created field and column
uday 16/10/2023 2699234404 fixed dropdown fontsize issues
*/
import React, {useContext, useState} from 'react';
import {useForm} from 'react-hook-form';
import {TextField, FormControl, Button, FormHelperText} from '@material-ui/core';
import {Controller} from 'react-hook-form';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import TriggerSearchTable from './TriggerSearchTable';
import {getDropDownData, postRunReport} from '../../../../redux/reducers/TriggerGroup';
import {useSelector, useDispatch} from 'react-redux';
import {useEffect} from 'react';
import DialogBox from './../../../../components/DialogBox';
import RunTriggerGroup from './RunTriggerGroup';
import {getFieldCode} from '../../../../redux/reducers/BRE/AddReportMaster';
import {
  getAllReportCreatedForData,
  fetchCreatedByDropDownData,
} from '../../../../redux/reducers/ReportMaster';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import GuiAutoComplete from '../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../components/FormComponents/GuiTextField';
import * as Yup from 'yup';
import {yupResolver} from '@hookform/resolvers/yup';
import {createdByOptions} from '../../../../util/CreatedByForOptions';

export default function TriggerSearchTrigger({
  setValue,
  nightJobSearchTrigger = false,
  setTriggerSearchCode,
  setSearchTrigger,
  seTriggerData,
  setRowSelected,
}) {
  const [searchData, setSearchData] = useState({});
  const [submit, setSubmit] = useState(false);
  const [runClicked, setRunClicked] = useState(false);
  const [mainRunClicked, setMainRunClicked] = useState(false);
  const [rowData, setRowData] = useState({});
  const StatusOptions = [
    {key: 'Y', value: 'Draft'},
    {key: 'N', value: 'Completed'},
  ];
  const dispatch = useDispatch();
  const {createdByData} = useSelector(({reportMaster}) => reportMaster);

  const searchSessionBatchTrigger = JSON.parse(sessionStorage.getItem('searchBatchTrigger'));
  // Form field initial values(2700423152)
  const initialValues = {
    groupCode: '',
    description: '',
    accessType: null,
    groupType: null,
    createdBy: '',
    createdDate: null,
    isDraft: nightJobSearchTrigger ? {key: 'N', value: 'Completed'} : '',
  };
  const validationSchema = Yup.object().shape({
    createdDate: Yup.date().typeError('Invalid date format').nullable(),
  });
  const {
    handleSubmit,
    control,
    reset,
    errors,
    setValue: setFieldValue,
  } = useForm({
    mode: 'all',
    defaultValues:
      searchSessionBatchTrigger && !nightJobSearchTrigger ?
        searchSessionBatchTrigger :
        initialValues,
    resolver: yupResolver(validationSchema),
  });
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const {fieldCodeData} = useSelector(({addReportMaster}) => addReportMaster);
  // set search data(2700423152)
  const onSubmit = (data) => {
    setSearchData(data);
    setSubmit(true);
    if (!nightJobSearchTrigger) {
      sessionStorage.setItem('searchBatchTrigger', JSON.stringify(data));
    }
  };

  const closeDialog = () => {
    setRunClicked(false);
  };

  // fetch Access Type dropdown data(2700423152)
  useEffect(() => {
    dispatch(getDropDownData());
    dispatch(getFieldCode());
  }, []);

  useEffect(() => {
    dispatch(fetchCreatedByDropDownData('batchtrigger'));
  }, [dispatch]);

  const onClear = () => {
    const data = {
      groupCode: '',
      description: '',
      accessType: null,
      groupType: null,
      createdBy: '',
      createdDate: null,
      isDraft: nightJobSearchTrigger ? {key: 'N', value: 'Completed'} : '',
    };
    setSearchData(data);
  };
  useEffect(() => {
    if (nightJobSearchTrigger) {
      setSearchData({...initialValues, isDraft: {key: 'N', value: 'Completed'}});
    } else {
      setSearchData({...initialValues, isDraft: ''});
    }
  }, [nightJobSearchTrigger]);
  useEffect(() => {
    if (mainRunClicked) {
      dispatch(
        postRunReport({
          groupCode: rowData?.groupCode ? rowData?.groupCode : '',
          triggerGroupId: rowData?.triggerGroupId ? rowData?.triggerGroupId : '',
        }),
      );
      setRowData('');
      setMainRunClicked(false);
    }
  }, [mainRunClicked, rowData]);
  useEffect(() => {
    dispatch(getAllReportCreatedForData());
  }, []);
  return (
    <>
      <div className={`${nightJobSearchTrigger ? classes.dialoguecardStyles : ''}`}>
        <h2 className="search-title">Batch Triggers Search</h2>
        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <div className="form-row standard-field-textfields new-standard-textfields align-items-center">
            <div
              className={`${
                nightJobSearchTrigger ?
                  'col-sm-6 col-md-4 col-lg-4 col-xl-4 form-group' :
                  'col-sm-6 col-md-4 col-lg-4 col-xl-4 form-group'
              }`}
            >
              <FormControl variant="outlined" fullWidth>
                <Controller
                  render={({value, onChange}) => (
                    <TextField
                      className={` ${classes.labelName}`}
                      placeholder="Enter Batch Trigger Name"
                      margin="dense"
                      name="groupCode"
                      variant="outlined"
                      label="Batch Trigger Name"
                      value={value}
                      onChange={onChange}
                      error={Boolean(errors.groupCode?.message)}
                      fullWidth
                    />
                  )}
                  control={control}
                  name="groupCode"
                />
              </FormControl>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4 form-group">
              <FormControl variant="outlined" fullWidth>
                <Controller
                  render={({value, onChange}) => (
                    <TextField
                      className={` ${classes.labelName}`}
                      placeholder="Enter Batch Trigger Description"
                      margin="dense"
                      name="description"
                      variant="outlined"
                      label="Batch Trigger Description"
                      value={value}
                      onChange={onChange}
                      error={Boolean(errors?.description?.message)}
                      fullWidth
                    />
                  )}
                  control={control}
                  name="description"
                />
              </FormControl>
            </div>

            <div className="col-sm-6 col-md-4 col-lg-2 col-xl-2 form-group">
              <FormControl margin="dense" variant="standard" fullWidth>
                <Controller
                  render={(props) => (
                    <GuiAutoComplete
                      {...props}
                      // classes={`${
                      //   !nightJobSearchTrigger
                      //     ? {
                      //         popper: classes.popper,
                      //         option: classes.option,
                      //       }
                      //     : ""
                      // }`}
                      classes={{
                        popper: classes.popper,
                        option: classes.option,
                      }}

                      id="accessType"
                      size="small"
                      autoHighlight
                      options={fieldCodeData}
                      getOptionDisabled={(option) => option.valueCode === null}
                      getOptionLabel={(option) => {
                        return option && option?.description ? option?.description : '';
                      }}
                      renderInput={(params) => (
                        <GuiTextField
                          className={` ${classes.labelName}`}
                          {...params}
                          variant="outlined"
                          fullWidth
                          label="Filter Method"
                          name="accessType"
                          error={Boolean(errors?.accessType?.message)}
                          placeholder="Select Filter Method"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: 'off',
                          }}
                        />
                      )}
                      onChange={(_, data) => {
                        props.onChange(data);
                      }}
                    />
                  )}
                  name="accessType"
                  control={control}
                />
              </FormControl>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-2  col-xl-2 form-group">
              <Controller
                render={({onChange, value}) => (
                  <GuiAutoComplete
                    classes={{
                      option: classes.option,
                    }}
                    id="createdBy"
                    size="small"
                    options={createdByData}
                    value={value}
                    getOptionLabel={(option) => {
                      return option && option?.userLoginName ? option?.userLoginName : '';
                    }}
                    renderOption={(option) => {
                      return createdByOptions(option);
                    }}
                    onChange={(_, data) => {
                      onChange(data);
                    }}
                    renderInput={(params) => (
                      <div className="select-field">
                        <GuiTextField
                          {...params}
                          className={` ${classes.labelName}`}
                          variant="outlined"
                          margin="dense"
                          label="Created By"
                          placeholder="Select Created By"
                        />
                      </div>
                    )}
                  />
                )}
                name="createdBy"
                control={control}
              />
            </div>
            <div className="col-sm-6 col-md-4 col-lg-2 col-xl-2 form-group">
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <FormControl variant="outlined" fullWidth>
                  <Controller
                    render={({value}) => (
                      <KeyboardDatePicker
                        className={` account-date-picker ${classes.labelName}`}
                        orientation="portrait"
                        format="MM/dd/yyyy"
                        value={value}
                        autoOk
                        inputVariant="outlined"
                        margin="dense"
                        placeholder="MM/DD/YYYY"
                        fullWidth
                        label="Date Created"
                        helperText={null}
                        error={Boolean(errors?.createdDate?.message)}
                        onChange={(date) => {
                          setFieldValue('createdDate', date);
                          return {value: date};
                        }}
                      />
                    )}
                    control={control}
                    name="createdDate"
                  />
                </FormControl>
              </MuiPickersUtilsProvider>
              <FormHelperText variant="outlined">
                {errors?.createdDate?.message ? errors?.createdDate?.message : ''}
              </FormHelperText>
            </div>
            <div className={`col-sm-6 col-xs-6 col-md-4 col-lg-2 col-xl-2 form-group`}>
              <FormControl margin="dense" variant="outlined" fullWidth>
                <Controller
                  render={(props) => (
                    <GuiAutoComplete
                      {...props}
                      classes={{
                        option: classes.option,
                      }}
                      id="isDraft"
                      size="small"
                      autoHighlight
                      disabled={nightJobSearchTrigger}
                      options={StatusOptions}
                      getOptionLabel={(option) => {
                        return option && option.value;
                      }}
                      renderInput={(params) => (
                        <GuiTextField
                          className={` ${classes.labelName}`}
                          {...params}
                          variant="outlined"
                          fullWidth
                          label="Status"
                          name="isDraft"
                          placeholder="Select Status"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: 'off',
                          }}
                        />
                      )}
                      onChange={(_, data) => {
                        props.onChange(data);
                      }}
                    />
                  )}
                  name="isDraft"
                  control={control}
                />
              </FormControl>
            </div>
            <div className="col-sm-6 col-md-12 col-lg-3 col-xl-3 form-group">
              <div className="d-flex justify-content-md-center justify-content-lg-start">
                <Button
                  type="button"
                  onClick={() => {
                    reset(initialValues);
                    onClear();
                    sessionStorage.removeItem('searchBatchTrigger');
                    setSubmit(true);
                  }}
                  variant="outlined"
                  className={`reset-btn mr-1 ${classes.buttonRoot}`}
                >
                  Reset
                </Button>
                <Button
                  type="submit"
                  variant="outlined"
                  className={`search-btn ml-1 ${classes.buttonRoot}`}
                >
                  Search
                </Button>
              </div>
            </div>
          </div>
        </form>

        <div>
          <TriggerSearchTable
            searchData={searchData}
            setSearchData={setSearchData}
            submit={submit}
            setSubmit={setSubmit}
            setValue={setValue}
            setRunClicked={setRunClicked}
            setRowData={setRowData}
            nightJobSearchTrigger={nightJobSearchTrigger}
            setTriggerSearchCode={setTriggerSearchCode}
            setSearchTrigger={setSearchTrigger}
            seTriggerData={seTriggerData}
            setRowSelected={setRowSelected}
          />
        </div>
        <DialogBox
          open={runClicked}
          dialogClose={closeDialog}
          title="Run Batch Trigger"
          fullWidth
          maxWidth={'xl'}
          classes={{paper: classes.dialogPaper}}
        >
          <RunTriggerGroup rowData={rowData} />
        </DialogBox>
      </div>
    </>
  );
}
